import * as React from "react";
import { Path, G, ClipPath, Defs, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const GRIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="GR" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="M0 0h16v12H0V0Z"
        clipRule="evenodd"
      />
      <Path fill="#4564F9" d="M.014 2.75h16v1.5h-16z" />
      <Path
        fill="#4564F9"
        fillRule="evenodd"
        d="M0 0h16v1.5H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#4564F9"
        d="M-.029 5.5h16V7h-16zM.056 8.2h16v1.5h-16zM.051 10.75h16v1.5h-16z"
      />
      <Path
        fill="#4564F9"
        fillRule="evenodd"
        d="M0 0h8v7H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="M3.236 0h1.582v2.75H8v1.893H4.818V7.5H3.236V4.643H0V2.75h3.236V0Z"
        clipRule="evenodd"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
